import React from 'react';
import PropTypes from 'prop-types';

import GatesProgressBar from './gates_progress/bar';
import NotifyLead from './notify_lead';

export default function LeadVaultProgress({ compact, lead }) {
  const leadInfo = {
    accountNotVerified: lead.accountStatus === 'Not Verified',
    caNotSigned: !lead.signedCa,
    pendingApproval: lead.approvalStatus && !['approved', 'auto_approved'].includes(lead.approvalStatus), // waitlisted
    profileNotComplete: !(lead.profileId && lead.profileUserType),
    viewDocsPrompt: !lead.documentsViewed,
    waitlistApproved: ['approved', 'auto_approved'].includes(lead.approvalStatus)
  };

  return (
    <React.Fragment>
      <NotifyLead
        lead={lead}
        leadInfo={leadInfo}
      />
      {lead.propertyVaultProfiles.map(pvp => (
        <GatesProgressBar
          caSigned={!!pvp.caSigned}
          compact={compact}
          key={`${pvp.id}-${pvp.saleOrLease}`}
          lead={lead}
          leadInfo={leadInfo}
          saleOrLease={pvp.saleOrLease}
          showSaleOrLease={lead.propertyVaultProfiles.length > 1}
          userType={lead.profileUserType}
        />
      ))}
    </React.Fragment>
  );
}

LeadVaultProgress.propTypes = {
  compact: PropTypes.bool,
  lead: PropTypes.shape({
    accountStatus: PropTypes.string,
    approvalStatus: PropTypes.string,
    documentsViewed: PropTypes.bool,
    profileId: PropTypes.number,
    profileUserType: PropTypes.string,
    propertyVaultProfiles: PropTypes.arrayOf(PropTypes.shape({
      caSigned: PropTypes.bool,
      id: PropTypes.number,
      saleOrLease: PropTypes.string
    })).isRequired,
    signedCa: PropTypes.bool
  }).isRequired
};
